import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, VerificationSteps } from '../../store/Auth/LoginStore';
import '../../css/auth.css';
import { isStringNullOrWhiteSpace } from '../../tools/validator';
import { Redirect } from 'react-router-dom';
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/
import { SVMLogo } from '../Controls/SVMLogo';
import ScriptTag from 'react-script-tag';
import { LoadingBar } from '../Controls/LoadingBar';

class Login extends React.Component {

    componentWillMount() {
        this.props.purge();
        this.props.notification();
    }

    handleLogin = (event) => {

        event.preventDefault();

        if (!isStringNullOrWhiteSpace(this.refs.username.value) && !isStringNullOrWhiteSpace(this.refs.password.value)) {
            this.props.login(this.refs.username.value, this.refs.password.value);
        }
    }

    handleKeyDown = function (e) {
        if (e.key === 'Enter' && e.shiftKey === false) {
            e.preventDefault();
            this.handleLogin(e);
        }
    };

    handlePrivacy = (event) => {
        event.preventDefault();
        this.openPopUpCenter("/SMPAC/PACPrivacyPolicyVersion.aspx?system=pac", "Privacy", 620, 520);
    }

    openPopUpCenter(url, title, w, h) {
        // from privacyPolicy.js
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

        const left = width / 2 - w / 2 + dualScreenLeft;
        const top = height / 2 - h / 2 + dualScreenTop;
        const newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h

            + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    }

    renderLoadingText() {
        if (this.props.isLoading)
            return (
                <div>
                    <LoadingBar isLoading={this.props.isLoading} />
                </div>
            );

        return '';
    }

    renderLoginBox() {
        if (this.props.data.step === VerificationSteps.EmailVerification) {
            return <Redirect to='/EmailVerification' />;
        }
        else if (this.props.data.step === VerificationSteps.Skip) {
            return <Redirect to='/Gateway' />;
        }
        else if (this.props.data.step === VerificationSteps.Verify2FA) {
            return <Redirect to='/Verify2FA' />;
        }

        return (
            <div>
                <div className='row m-0'>
                    <div className='col-3 mr-1 text-right'>
                        <label htmlFor='username'>Username</label>
                    </div>
                    <div className='col-6 p-0 m-0'>
                        <input id='username' ref='username' type='text' className='w-100' autoComplete='off' required onKeyDown={(e) => { this.handleKeyDown(e); }} />
                    </div>
                </div>
                <div className='row pt-1 m-0'>
                    <div className='col-3 mr-1 text-right'>
                        <label htmlFor='password'>Password</label>
                    </div>
                    <div className='col-6 p-0 m-0'>
                        <input id='password' ref='password' type='password' className='w-100' required onKeyDown={(e) => { this.handleKeyDown(e); }} />
                    </div>
                    <div className='col-2 p-0 m-0 ml-3 text-left'>
                        <button className='btn btn-primary' onClick={this.handleLogin}>Login</button>
                    </div>
                </div>
                {this.renderLoadingText()}
            </div>
        );
    }

    getOutageNotification () {
        return { __html: this.props.systemMessage};
    }

    renderOutageNotification() {
        if(this.props.systemMessage !== undefined
            && this.props.systemMessage.length > 0) {
                return (
                    <div className='justify-content-center'>
                        <div className='pacbodylargered text-center'>
                            <div dangerouslySetInnerHTML={this.getOutageNotification()} />
                        </div>
                    </div>
                );
            }
            return "";
        
    }

    renderSystemNotification() {
        let message;
        if (this.props.hasErrorOccured)
            message =
                <span className='pacbodylargered'>
                    The login attempt was unsuccessful for one of the following reasons:<br />
                    - The username or password was not recognised.<br />
                    - The account is locked after 5 or more incorrect login attempts.<br />
                    - The account has been disabled.<br /><br />
                If you have forgotten your password, it can be reset <a href='../SMPAC/Admin/ResetPassword.aspx'>here</a>. If you think your account has been locked or disabled, please contact <a href='mailto:silvermousehelpdesk@silvermouse.com'>silvermousehelpdesk@silvermouse.com</a>
                </span>
                ;
        return (
            <div className='row justify-content-center'>
                <div className='pt-2 loginSeperator'>
                    {message}
                </div>
            </div>
        );
    }

    render() {

        return ( 
            <div role='main' className='pt-3'>
                <h1 class='visuallyhidden'>Silvermouse Login Page</h1>
                <div className='row justify-content-center'>
                    <div className='loginLogo text-right mr-3'>
                        <div className=''>
                            <SVMLogo />
                        </div>
                    </div>
                    <div className=''>
                        <div className='loginBox'>
                            {this.renderLoginBox()}
                        </div>
                        <div className='pt-2 m-0 text-right loginBoxLinks'>
                            <a href='#' onClick={this.handlePrivacy} aria-label='Open Privacy Policy popup'>Privacy</a>
                            <span role='presentation' className='pl-2 pr-2'>|</span>
                            <a href='../SMPAC/Admin/ResetPassword.aspx' aria-label='Redirect to Reset Password page'>Forgotten Password</a>
                            <span role='presentation' className='pl-2 pr-2'>|</span>
                            <a href='../registration/Registration.aspx' aria-label='Redirect to New User Request page'>New User</a>
                        </div>
                    </div>
                </div>
                {this.renderSystemNotification()}
                {this.renderOutageNotification()}
            </div >

        );
    }
}

export default connect(
    state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Login);



// WEBPACK FOOTER //
// ./src/components/Auth/Login.js